import parse from 'date-fns/parse'
import parseISO from 'date-fns/parseISO'
import isValid from 'date-fns/isValid'
import isMatch from 'date-fns/isMatch'

import { notify } from '@offerzen/react-utils'

/**
 * Parses a given date or date string into a Date object.
 * If the input is already a Date object or a number, it will be returned as is.
 * If the input is a valid ISO date string with fractional seconds, it will be parsed using date-fns parseISO.
 * If the input matches 'yyyy-MM-dd HH:mm:ss XX', it will be parsed in the format 'yyyy-MM-dd HH:mm:ss XX' using date-fns parse.
 * If the input matches 'yyyy-M-d', it will be parsed in the format 'yyyy-M-d' using date-fns parse.
 * If the input matches 'yyyy-MM-dd', it will be parsed in the format 'yyyy-MM-dd' using date-fns parse.
 * If the input is invalid or null, it returns null.
 *
 * @param {Date|number|string} date - The date to be parsed. Can be a Date object, a timestamp, or a date string.
 * @returns {Date|null} Returns a Date object if the input is valid, otherwise returns null.
 */

export const parseDate = date => {
  if (!date) return null

  if (typeof date === 'number' || date instanceof Date) {
    return date
  }

  if (isMatch(date, 'yyyy-M-d')) {
    return parse(date, 'yyyy-M-d', new Date())
  }

  if (isMatch(date, 'yyyy-MM-dd')) {
    return parse(date, 'yyyy-MM-dd', new Date())
  }

  if (isMatch(date, 'yyyy-MM-dd HH:mm:ss XX')) {
    return parse(date, 'yyyy-MM-dd HH:mm:ss XX', new Date())
  }

  const parsedDate = parseISO(date, { additionalDigits: 1 })

  if (isValid(parsedDate)) {
    return parsedDate
  }

  notify(`Invalid date format (${date}). The date could not be parsed by date-fns.`)
  return null
}
